module.exports = __webpack_public_path__ + "static/flags/AV-a143f847d7ab021d94e9fb91189b0526.gif";